// Maximální povolené délky stringů v inputu
export const MAX_INPUT_LENGTH_XXL = 2048;
export const MAX_INPUT_LENGTH_XL = 1024;
export const MAX_INPUT_LENGTH_L = 256;
export const MAX_INPUT_LENGTH_M = 128;
export const MAX_INPUT_LENGTH_S = 64;
export const MAX_INPUT_LENGTH_XS = 32;
